{
  "Download Weave App": "Download Weave App",
  "Set up your features and access training material below.": "Set up your features and access training material below.",
  "Welcome to the Weave Portal.": "Welcome to the Weave Portal."
}
